import { render, staticRenderFns } from "./QrcodeDownload.vue?vue&type=template&id=f36d343e&scoped=true&"
import script from "./QrcodeDownload.vue?vue&type=script&lang=js&"
export * from "./QrcodeDownload.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeDownload.vue?vue&type=style&index=0&id=f36d343e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36d343e",
  null
  
)

component.options.__file = "QrcodeDownload.vue"
export default component.exports